import {
  ReplaySubject,
} from "rxjs";

export const sessions_observable = new ReplaySubject([]);
export const calllog_observable = new ReplaySubject([]);
// export const friends_observable = new ReplaySubject([]);
